import { createFileRoute } from "@tanstack/react-router";
import AccountsSpend from "@/components/AccountsSpend";

function RouteComponent() {
  return <AccountsSpend />;
}

export const Route = createFileRoute("/_authenticated/accounts/spend")({
  component: RouteComponent,
  staticData: { page: ["accounts", "sales", "finance", "deals"] },
});
